import Api, { PerformerRequest, Unit } from '@silbo/core';
import { startOfDay, subDays } from 'date-fns';

const ARCHIVED_DAYS_THRESHOLD = 1;

export const getArchivedRequestsQuery = (date: Date, units: Unit[]) => {
  return new Api.Query(PerformerRequest)
    .containedIn('status', ['ACCEPTED', 'REJECTED', 'REROUTED'])
    .greaterThan('fulfilledAt', startOfDay(subDays(date, ARCHIVED_DAYS_THRESHOLD)))
    .lessThan('fulfilledAt', date)
    .include([
      'request',
      'request.visit',
      'request.originAccommodation.unit',
      'request.originAccommodation.bed',
      'performer',
    ])
    .containedIn('performer', units)
    .descending('fulfilledAt');
};
